import { MouseEvent } from 'react'

import { Button } from '@mantine/core'

import { showAlert } from '#components/Modals'
import { useMst } from '#state'

export function ReindexDocsForm({ orgId }: { orgId: string }) {
  const { apiClient } = useMst()

  const onClick = async (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    try {
      await apiClient.reindexDocsInOrgByStaff({ orgId })
      showAlert({
        title: 'Success',
        children: 'A reindex job has been triggered',
      })
    } catch (e) {
      showAlert({
        title: 'Error',
        // oxlint-disable-next-line typescript/no-explicit-any
        children: (e as any).message,
      })
    }
  }

  return (
    <form className="s-form s-form--inline">
      <p>
        Reindexing all the documents in a workspace in ElasticSearch can resolve
        problems with search results.
      </p>
      <Button onClick={onClick}>Reindex documents</Button>
    </form>
  )
}
